import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Users Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Users Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/users',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
